import React from 'react';
import '../../../styles/global.css';

function DoubleUseBags() {
  return (
    <div className="body-container">
      <h1>Double-Use Bags</h1>
      <h4>Sept 2022</h4>
      <h2>Explore the project <a href='https://tangmonica.github.io/double-use-bags/' target="_blank" rel="noopener noreferrer">here</a> and the code <a href='https://github.com/tangmonica/double-use-bags' target="_blank" rel="noopener noreferrer">here</a>.</h2>
      <p>A website made with p5.js that showcases my stash of paper and plastic bags. Visit the site and click on a bag to hear its rustle sound!</p>
      <img src={require('./double-use-bags.png')} />
    </div>
  );
};

export default DoubleUseBags;
